import React, { useContext } from 'react'
import portals from '../../../../enums/portalsEnum'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../styles'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import SubHeader from './SubHeader'
import { useMediaQuery } from 'react-responsive'
import { FormattedMessage } from 'react-intl'
import { modalTypes } from '../../../../enums/modalTypeEnum'
import { typeYfDisplay } from '../../../../enums/yfManagerEnums'
import YFDisplay from '../../../yf_popin/YFDisplay'
import links from '../../../../enums/linksEnum'
import { useHistory } from 'react-router-dom'
import { MakeRequestContext } from '../MakeRequestContext'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            headerStyleLargeScreen: {
                '& #logo': {
                    margin: '2vw',
                    width: '100%',
                    maxWidth: 150,
                    cursor: 'pointer'
                }
            },
            headerStyleSmallScreen: {
                width: '100%',
                margin: 0,
                height: '10vw',
                minHeight: 50,

                '& > div:first-child': {
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',

                    '& #logo': {
                        height: '100%',
                        marginRight: 15
                    }
                }
            },
            iconStyle: {
                background: theme.palette.blue['5'],
                padding: 12,
                borderRadius: '100%',
                color: theme.palette.blue.main,
                cursor: 'pointer'
            },
            imgStyle: {
                height: 66,
                width: 66,
                marginRight: 10,
                '& svg': {
                    fill: theme.palette.blue.main,
                    width: 46,
                    height: 46
                },
                '& img': {
                    width: 66,
                    height: 66
                }
            }
        }
    )
)

interface AcceptingProps {
    closeDialog: () => void,
    fromType?: modalTypes,
    title?: string,
    displaySubheader?: boolean
}

type HeaderProps = AcceptingProps

const Header: React.FC<HeaderProps> = (
    {
        closeDialog,
        fromType = modalTypes.demandes,
        title,
        displaySubheader = true
    }
) => {
    const classes = useStyle()
    const history = useHistory()
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )
    const { step } = useContext(MakeRequestContext)

    const headerClass: ClassValue = classNames(
        'row middle-xs',
        classes.flexBetween,
        {
            [classes.headerStyleLargeScreen]: isLargeScreen,
            [classes.headerStyleSmallScreen]: !isLargeScreen
        }
    )

    const titleSmallScreenClass: ClassValue = classNames(
        classes.title5,
        classes.colorBlue
    )

    const redirectTo = (link: string) => {
        closeDialog()
        history.push(link)
    }

    return (
        <>
            <div className={headerClass}>
                {
                    isLargeScreen ? (
                        <div className="col-md-2">
                            {
                                step < 5 && (
                                    <img
                                        src={process.env.REACT_APP_TARGET === portals.residence ? 'img/youFirst.jpg' : 'img/youFirstCampus.svg'}
                                        alt="Logo Youfirst"
                                        id="logo"
                                        onClick={() => redirectTo(links.dashboard)}
                                    />
                                )
                            }
                        </div>
                    ) : (
                        <div className="col-xs-8">
                            {
                                step < 5 && (
                                    <>
                                        <div className={classes.imgStyle}><YFDisplay type={typeYfDisplay.REQUEST} /></div>
                                        {
                                            fromType === 'request' ? (
                                                <span className={titleSmallScreenClass}>
                                                    <FormattedMessage
                                                        id="requests.makeRequest.title"
                                                        defaultMessage="Déposer une demande"
                                                        description="Modal title mobile"
                                                    />
                                                </span>
                                            ) : (
                                                <span className={titleSmallScreenClass}>
                                                    <FormattedMessage
                                                        id="requests.response.title"
                                                        defaultMessage="Déposer une réponse"
                                                        description="Modal title mobile"
                                                    />
                                                </span>
                                            )
                                        }
                                    </>
                                )
                            }

                        </div>
                    )
                }


                <div className="col-xs-4 col-md-2">
                    <div className="row middle-xs end-xs">
                        <div className="col-xs-12 col-md-4">
                            <CloseIcon
                                onClick={() => redirectTo(history.location.pathname)}
                                className={classes.iconStyle}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {
                step < 5 && isLargeScreen && displaySubheader &&
				<SubHeader
					fromType={fromType}
					title={title}
				/>
            }
        </>
    )
}

export default Header
